import User from "./User";

export default class Comment {
  constructor({
    id = Number.NaN,
    dateCreated = null,
    authorEmail = "",
    content = "",
    author = null,
  } = {}) {
    this.id = Number.parseInt(id, 10);
    this.dateCreated = dateCreated ? new Date(dateCreated) : null;
    this.authorEmail = authorEmail;
    this.content = content;
    this.author = author ? new User(author) : null;
  }
}